import { BROADCAST_CREATE_SANDBOX_MEETING } from 'actions/Types';

/**
 * We use this action to create the sandbox meeting when the url params are not available.
 * THis is to cater specifically for the standalone checker page.
 */

const createStandAloneSandboxMeetings = () => {
  return dispatch => {
    const action = {
      type: BROADCAST_CREATE_SANDBOX_MEETING,
      request: async apiClient => {
        // Call the API to create the sandbox meeting @ Chime
        const { sandboxMeetingResponse } =
          await apiClient.broadcast.createSandboxMeeting();
        const meetingId = sandboxMeetingResponse.Meeting.MeetingId;

        const { attendeeResponse } =
          await apiClient.broadcast.createSandboxMeetingAttendee(meetingId);

        return {
          sandboxMeetingResponse,
          attendeeResponse
        };
      }
    };

    dispatch(action);
  };
};

export default createStandAloneSandboxMeetings;
